var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 6.66699H6.67508M1.66675 4.33366L1.66675 8.06242C1.66675 8.47007 1.66675 8.6739 1.7128 8.86571C1.75363 9.03577 1.82097 9.19835 1.91235 9.34747C2.01542 9.51566 2.15954 9.65979 2.4478 9.94804L8.83832 16.3386C9.82836 17.3286 10.3234 17.8236 10.8942 18.0091C11.3963 18.1722 11.9372 18.1722 12.4393 18.0091C13.0101 17.8236 13.5051 17.3286 14.4952 16.3386L16.3383 14.4954C17.3284 13.5054 17.8234 13.0104 18.0089 12.4395C18.172 11.9374 18.172 11.3966 18.0089 10.8944C17.8234 10.3236 17.3284 9.82861 16.3383 8.83856L9.94779 2.44804C9.65954 2.15979 9.51541 2.01566 9.34722 1.91259C9.1981 1.82121 9.03553 1.75387 8.86547 1.71304C8.67365 1.66699 8.46983 1.66699 8.06218 1.66699L4.33341 1.66699C3.39999 1.66699 2.93328 1.66699 2.57676 1.84865C2.26316 2.00844 2.00819 2.2634 1.8484 2.57701C1.66675 2.93353 1.66675 3.40024 1.66675 4.33366ZM7.08342 6.66699C7.08342 6.89711 6.89687 7.08366 6.66675 7.08366C6.43663 7.08366 6.25008 6.89711 6.25008 6.66699C6.25008 6.43687 6.43663 6.25033 6.66675 6.25033C6.89687 6.25033 7.08342 6.43687 7.08342 6.66699Z",
    stroke: "#505050",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRental);
export default __webpack_public_path__ + "static/media/rental.3fda65dede2d818de0da6ed30de5e9fa.svg";
export { ForwardRef as ReactComponent };